import { GenIcon } from '../helpers/IconBase.es.js';

const RatingAlternativeOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M11.9999 3.45825L14.9752 8.41945L20.613 9.71606L16.814 14.0789L17.3231 19.8414L11.9999 17.5766L6.67664 19.8414L7.18567 14.0789L3.38672 9.71606L9.02452 8.41945L11.9999 3.45825Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { RatingAlternativeOutlined };
